<template>
  <v-app class="off-grey">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import './src/styles/index.scss';
</style>
